import { Typography } from "@mui/material";
import { IMessageContentTypeBubble } from "../../MessagePanel";

const TextContent = ({ message }: IMessageContentTypeBubble) => {
  let messageData = message.getMessage();
  return (
    <Typography
      component="span"
      variant="body1"
      data-testid="fallback-message-content"
      sx={{ whiteSpace: "pre-wrap" }}
      dangerouslySetInnerHTML={{
        __html: messageData.fallbackMessage,
      }}
    />
  );
};

export default TextContent;
